import { Image } from "antd";
import { envChangeType, envType } from "../../../../../../plugins/utils";
import styles from "./styleModule";

const AgentIcon = ({ color1 = "#F4BFAE", color2 = "#EFA78C", strokeColor = "white" }) => {
  const background = (
    <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 57 57" fill="none">
      <circle
        cx="28.5"
        cy="28.5"
        r="27.5"
        fill="url(#paint0_linear_2886_10375)"
        stroke={strokeColor}
        stroke-width="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2886_10375"
          x1="28.5"
          y1="0"
          x2="28.5"
          y2="57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={color1} />
          <stop offset="1" stop-color={color2} />
        </linearGradient>
      </defs>
    </svg>
  );
  const agentIcon = (
    <Image
      src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${envChangeType("REACT_APP_SHOW_THEATER", envType.BOOLEAN) ? "tabbar-middle-shorts" : "tabbar-middle"}.webp`}
      alt="agentIcon"
      width={40}
      height={40}
      preview={false}
    />
  );

  return (
    <div className={styles.background}>
      {background}
      <div className={styles.homeIcon}>{agentIcon}</div>
    </div>
  );
};

export default AgentIcon;
